// The restore endpoint answers 422 with either a JSON:API `errors` array or a
// raw ActiveModel errors hash (e.g. { name: ['has already been taken'] }).
// Surface the first human-readable reason from whichever shape we received,
// or null when nothing usable is present.
export default function restoreErrorMessage(errors) {
  if (Array.isArray(errors)) {
    return errors[0]?.detail || errors[0]?.title || null;
  }

  if (errors && typeof errors === 'object') {
    const [field, messages] = Object.entries(errors)[0] || [];
    const message = Array.isArray(messages) ? messages[0] : messages;
    if (message) return field ? `${field} ${message}` : message;
  }

  return null;
}
